// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/shared/colors.css\"","ot_primary":"#3395FF","graphHeader":"graphHeader__graphHeader___32nex","dashboard":"graphHeader__dashboard___1qAAt","buttonGroup":"graphHeader__buttonGroup___2xAJi fonts__capsTitle___12K2H","navigation":"graphHeader__navigation___25kZY"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/series/tabbedGraphs/graphHeader.css
// module id = 1133
// module chunks = 0